<template>
	<div>
		<el-container>
			<el-header>
				<Hearder></Hearder>
			</el-header>
			<el-main>
				<AppMain></AppMain>
			</el-main>
			<!-- <el-footer>
				<Footer></Footer>
			</el-footer> -->
		</el-container>
	</div>
</template>

<script>
	export default {
		name: 'homeIndex',
		components: {
			Hearder: () => import('./components/hearder'),
			AppMain: () => import('./components/appMain'),
			Footer: () => import('./components/footer')
		},
		data() {
			return {}
		},
		mounted() {},
		methods: {}
	}
</script>

<style scoped>
	@import url("./css/layout.css");
</style>